import { createContext } from 'react';

import type { AppConfig } from '../models';

export const appConfigContextDefaultValue: AppConfig = {
  isFrontPage: false,
  isStandalone: false,
  showFooterOnDesktop: false,
};

export const appConfigContext = createContext<AppConfig>(appConfigContextDefaultValue);

export const AppConfigProvider = appConfigContext.Provider;
